<template>
  <div v-loading="loading" >
    <p class="bg-info-lighter p-10"><i class="el-icon-warning-outline"></i> Une fiche technique de produit est associée à chaque type de produit. Vous pouvez modifier ces fiches techniques en sélectionnant le type de produit désiré.</p>
    <span class="fs-15 mb-20">Types de produit : </span>
    <el-tabs v-model="activeNames" class="m-20" >
      <el-tab-pane v-for="(type, index) in productTypes" :key="type.id" :label="type.name.fr + ' / '+type.name.en" :name="type.code"  :disabled="changeOrder">
        <el-row class="m-10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-button type="primary" :disabled="changeOrder" @click="openNewAttributeDialog(type)">Ajouter un attribut</el-button>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="text-right">
            <el-button @click="handleOrdering(type)" v-if="changeOrder==false" :disabled="model[type.code]==null || model[type.code].length==0">Réordonner <i class="el-icon-d-caret"></i></el-button>
            <el-button type="primary" v-if="changeOrder" @click="handleSave(type.code)">Sauvegarder</el-button>
            <el-button v-if="changeOrder" @click="handleCancel(type.code)">Annuler</el-button>
          </el-col>
        </el-row>
        <div v-if="model[type.code]!= null && model[type.code].length>0">
          <el-row class="m-20"><el-col><span class="fs-14">Attributs de la fiche technique :</span></el-col></el-row>
          <draggable  v-model="model[type.code]" handle=".handle" :move="onMove" v-bind="dragOptions" @start="drag = true" @end="drag = false" @change="orderChange">
            <transition-group type="transition" :name="'flip-list'">
              <div v-for="element in model[type.code]" :key="element.sequence" class="p-5 border m-5">
                <el-row type="flex">
                  <el-col :span="18" class="m-5">
                    <i class="mdi mdi-drag handle" v-if="orderable && producTypeInEdition.code==type.code"  @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                    <i class="mdi mdi-drag info-light-text" v-else  aria-hidden="true"></i>
                    <span class="fs-14">{{element.label.fr}} / {{element.label.en}}</span>
                  </el-col>
                  <el-col :span="6" class="text-right align-vertical-middel">
                    <el-button
                      size="mini"
                      circle
                      :disabled="changeOrder"
                      @click="handleEdition(element, type)"
                      ><i class="mdi mdi-lead-pencil fs-14"></i></el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      :disabled="changeOrder"
                      @click="handleDeleteAttribute(element, type)"
                      circle
                      ><i class="mdi mdi-delete fs-14" ></i></el-button>
                  </el-col>
                </el-row>
              </div>
            </transition-group>
          </draggable>
        </div>
        <div v-else class="text-center m-40">
          <span class="fs-14">Aucune fiche technique n'a été spécifié. Commencer par ajouter un attribut.</span>
        </div>
      </el-tab-pane>
    </el-tabs>
    <AttributeDialog :visible="attributeDialogVisible" :edit="attributeToEdit!=null ? attributeToEdit.label : null" @close="closeNewAttributeDialog"  @add="handleAddNewAttribute" @update="handleAttributeUpdated" title="attribute"></AttributeDialog>
  </div>
</template>
<script>

import CMSApi from '@/services/API/cmsAPI'
import draggable from 'vuedraggable';
import AttributeDialog from './label-dialog'
import Promise from 'bluebird'

export default {
	name: 'SpecificationByProductType',
  props : {

  },
	data() {
		return {
      attributeDialogVisible : false,
      activeNames : null,
      productTypes : [],
      drag : false,
      productItemPropertyLabels : [],
      model : {

      },
      backupModel : null,
      specificationIdToEdit : null,
      orderable : false,
      edition : true,
      producTypeInEdition : null,
      changeOrder : false,
      loading : false,
      attributeToEdit : null,
		}
	},
  components : {
    draggable,
    AttributeDialog
  },
  computed : {
    lang(){
      return this.$i18n.locale
    },
    dragOptions() {
      return {
        animation: 200,
        group: "code",
        disabled: !this.orderable,
        ghostClass: "ghost"
      };
    },
  },
  methods : {
    getSpecificationFromProductType(productTypeId){
      return CMSApi.getProductItemPropertyLabels(productTypeId)
    },
    deleteAttribute(attribute, force = false){
      let _this = this;
      return CMSApi.deleteProductItemPropertyLabels(attribute.id, force)
        .then(()=>_this.getSpecificationFromProductType(_this.producTypeInEdition.id))
        .then(spec=>{
          _this.model[_this.producTypeInEdition.code].splice(0);
          _.forEach(spec, s=>{
            _this.model[_this.producTypeInEdition.code].push(s);
          })
          this.$message.success('Attribut supprimé avec succès!');
        })
    },
    handleDeleteAttribute(attribute, productType){
      this.producTypeInEdition=productType;
      this.$confirm("Ceci supprimera l'attribut de façon permanente. Continuer?", 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        })
        .then(()=>this.deleteAttribute(attribute, false))
        .catch(err=>{
          if(err=='cancel'){
            this.$message('Suppression annulée!');
          } else {
            if (err.response.status === 409) {
              this.$confirm("Cet attribut est utilisé dans certaines fiches techniques. Voulez-vous tout de même le supprimer?", "Warning", {
                confirmButtonText: 'OK',
                cancelButtonText: 'Annuler',
                type: 'warning'
              })
              .then(() => this.deleteAttribute(attribute, true))
              .catch(err => {
                if(err=='cancel'){
                  this.$message('Suppression annulée!');
                } else {
                  this.$message.error('Oops! Une erreur est survenue!');
                }
              })
            }
          }
        })

    },
    handleAddNewAttribute(label){
      let _this = this;
      let newAttribute = {label, sequence:this.model[this.producTypeInEdition.code].length+1, productType:this.producTypeInEdition}
      return this.saveNewAttribute(newAttribute)
        .then(()=>_this.getSpecificationFromProductType(_this.producTypeInEdition.id))
        .then(spec=>{
          _this.model[_this.producTypeInEdition.code].splice(0);
          _.forEach(spec, s=>{
            _this.model[_this.producTypeInEdition.code].push(s);
          })
        })
      // this.model[this.producTypeInEdition.code].push(newAttribute);
    },
    handleAttributeUpdated(label){
      this.attributeToEdit.label = label;
      let _this = this;
      return CMSApi.updateProductItemPropertyLabels(this.attributeToEdit.id, this.attributeToEdit)
        .then(()=>_this.getSpecificationFromProductType(_this.producTypeInEdition.id))
        .then(spec=>{
          _this.model[_this.producTypeInEdition.code].splice(0);
          _.forEach(spec, s=>{
            _this.model[_this.producTypeInEdition.code].push(s);
          })
          _this.attributeToEdit = null;
        })
    },
    openNewAttributeDialog(productType){
      this.producTypeInEdition=productType;
      this.attributeDialogVisible=true;
    },
    closeNewAttributeDialog(){
      this.attributeDialogVisible=false;
    },
    handleSave(){
      this.loading = true;
      this.orderable = false;
      this.changeOrder = false;
      return this.saveSequence(this.model[this.producTypeInEdition.code])
      .then(()=>{

        this.loading = false;
        this.producTypeInEdition=null;
      }).catch(err=>{
        console.log(err);
        this.loading = false;
        this.$message.error('Une erreur est survenue lors de la sauvegarde. Veuillez réessayer plus tard.');

      })
      //Save new Attributes if exists
      //Change order if it has been change
    },
    saveNewAttribute(attribute){
      let newAttribute = {
        label : attribute.label,
        productType : {
          id : attribute.productType.id
        }
      };
      return CMSApi.saveProductItemPropertyLabels(newAttribute);
    },
    handleCancel(){
      this.model[this.producTypeInEdition.code] = this.backupModel;
      this.producTypeInEdition=null;
      this.orderable = false;
      this.changeOrder = false;
    },
    handleOrdering(productTypeCode){
      this.orderable = true;
      this.changeOrder = true;
      this.backupModel = _.cloneDeep(this.model[productTypeCode.code]);
      this.producTypeInEdition = productTypeCode;
    },
    handleEdition(attribute,productTypeCode){
      this.attributeToEdit = attribute;
      this.producTypeInEdition = productTypeCode;
      this.openNewAttributeDialog(productTypeCode);
    },
    orderChange(change){
      _.forEach(this.model[change.moved.element.productType.code], (t, index)=>{t.sequence = index+1})
      // return this.saveSequence(this.model[change.moved.element.productType.code]);
    },
    saveSequence(model){

      let postData = [];
      _.forEach(model, spec=>{
        postData.push({id:spec.id, sequence:spec.sequence, lockVersion:spec.lockVersion});
      })
      return CMSApi.updateProductItemPropertyLabelsSequence(postData)
        .then(()=>{
          _.forEach(model, spec=>{
            spec.lockVersion++;
          })
        })


    },
    fetchProductTypes(){
      return CMSApi.fetchProductTypes()
        .then(productTypes=>{
          this.productTypes = productTypes;
        })
    },
    fetchProductItemPropertyLabels(){
      return CMSApi.getProductItemPropertyLabels()
        .then(productItemPropertyLabels=>{
          this.productItemPropertyLabels = productItemPropertyLabels;
        })
    },
    setModel(){
      _.forEach(this.productTypes, t=>{
        this.$set(this.model, t.code, [])
        // this.model[t.code] = [];
      })
      _.forEach(this.productItemPropertyLabels, s=>{
        s.deleted = false;
        s.new = false;
        s.updated = false;
        this.model[s.productType.code].push(s);
      })
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
  },
  mounted(){
    this.loading = true;
    return this.fetchProductTypes()
      .then(()=>this.fetchProductItemPropertyLabels())
      .then(()=>this.setModel())
      .then(()=>{
        this.activeNames = this.productTypes!=null && this.productTypes.length>0 ? this.productTypes[0].code : null;
        this.loading = false;
      })
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';


.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.handle {
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.handle:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
}


</style>
